import { localizedStrings } from '@core/strings'
import React from 'react'
import { Box, Text } from '@fundamentals'
import {
  DateQuestionRules,
  QuestionTypeComponentType,
} from '@core/components/templateAnswersForm'
import { TextInput } from '@common/material'
import { DatePicker } from '@common/material/DatePicker'
import moment from 'moment'

const DateQuestion: QuestionTypeComponentType = ({
  question,
  inputProps: { value = question, onChange, ...inputProps } = {},
  readOnly,
}) => {
  const onChangeText = (date) => {
    const submissionText =
      question.questionType === 'DATE_ONLY'
        ? moment(date).format('YYYY-MM-DD')
        : date?.toISOString()

    onChange({
      ...value,
      submissionText,
    })
  }

  if (readOnly) {
    return (
      !!question.submissionText && (
        <Text data-test={`${question.id}-${question.questionType}`}>
          {moment(question.submissionText).format(
            question.questionType === 'DATE_ONLY'
              ? 'DD MMM YYYY'
              : 'DD MMM YYYY HH:mm',
          )}
        </Text>
      )
    )
  }

  return (
    <Box mt={2} data-test={`${question.id}-DATE`}>
      <DatePicker
        name='startDate'
        dataTest='request-date-input'
        withTime={question.questionType !== 'DATE_ONLY'}
        label={
          question.questionType === 'DATE_ONLY'
            ? localizedStrings.selectDate
            : localizedStrings.selectDateAndTime
        }
        slotProps={{
          textField: {
            variant: 'outlined',
            ...inputProps,
          },
          actionBar: {
            actions: ['today'],
          },
        }}
        slots={{
          textField: TextInput,
        }}
        value={value?.submissionText ? moment(value?.submissionText) : null}
        onChange={onChangeText}
        sx={{ width: '100%' }}
      />
    </Box>
  )
}

DateQuestion.rules = DateQuestionRules

export { DateQuestion }
